export default __webpack_public_path__ + "images/0x9c67ee39e3c4954396b9142010653f17257dd39c.png";